import { render, staticRenderFns } from "./addPartnerCp.vue?vue&type=template&id=bda0a020"
import script from "./addPartnerCp.vue?vue&type=script&lang=js"
export * from "./addPartnerCp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports